"use strict";

import axios from "@/plugins/axios";
// import router from "../../router";


export const publicApi = {
    namespaced: true,
    state: {
        news: [],
        departments: [],
        workshops: [],
        post: {},
        posts: [],
        courses: [],
        locations: [],
        users: [],
        postsLiked: [],
        sponsorsHomepage: [],
        postsAmount: 0,
        workshopBlogPosts: [],
        sponsorsVolkslauf: [],
    },
    getters: {
        getWorkshops: (state) => state.workshops,
        getLocations: (state) => state.locations,
        getPostsLiked: (state) => state.postsLiked,
        getCourses: (state) => state.courses,
        getDepartments: (state) => state.departments,
        getPostsAmount: (state) => state.postsAmount,
        getNews: (state) => state.news,
        getUsers: (state) => state.users,
        getPost: (state) => state.post,
        getBlogPosts: (state) => state.posts,
        getSponsorsHomepage: (state) => state.sponsorsHomepage,
        getSponsorsVolkslauf: (state) => state.sponsorsVolkslauf,
        getBlogPostsWorkshop: (state) => state.workshopBlogPosts,
    },
    mutations: {
        SET_POST: (state, payload) => { state.post = payload },
        SET_LOCATIONS: (state, payload) => { state.locations = payload },
        SET_POSTS: (state, payload) => { state.posts = payload },
        UPDATE_COURSES: (state, payload) => { state.courses = payload },
        SET_POSTS_AMOUNT: (state, payload) => { state.postsAmount = payload },
        UPDATE_WORKSHOPS: (state, payload) => { state.workshops = payload },
        UPDATE_DEPARTMENTS: (state, payload) => { state.departments = payload },
        UPDATE_NEWS: (state, payload) => { state.news = payload },
        SET_SPONSORS_H: (state, payload) => { state.sponsorsHomepage = payload },
        SET_SPONSORS_V: (state, payload) => { state.sponsorsVolkslauf = payload },
        UPDATE_USERS: (state, payload) => { state.users = payload },
        UPDATE_WORKSHOPS_BLOGPOSTS: (state, payload) => { state.workshopBlogPosts = payload },
    },
    actions: {
        async getNews({ commit }) {
            try {
                let res = (await axios.get("/public/news")).data;
                if (res.success)
                    commit("UPDATE_NEWS", res.data);
            } catch (e) {
                return e

            }
        },
        async getLocations({ commit }) {
            try {
                let res = (await axios.get("/public/locations")).data;
                if (res.success)
                    commit("SET_LOCATIONS", res.data);
            } catch (e) {
                return e

            }
        },

        async getSponsorsHomepage({ commit }) {
            try {
                let res = (await axios.get('/public/sponsors/homepage')).data;
                if (res.success) commit('SET_SPONSORS_H', res.data)
            } catch (error) {
                return error

            }
        },
        async getSponsorsVolkslauf({ commit }) {
            try {
                let res = (await axios.get('/public/sponsors/volkslauf')).data;
                if (res.success) commit('SET_SPONSORS_V', res.data)
            } catch (error) {
                return error
            }
        },
        async getUsers({ commit }) {
            try {
                let res = (await axios.get("/public/users")).data;


                if (res.success)
                    commit("UPDATE_USERS", res.data);
            } catch (e) {

                return e
            }
        },
        async getDepartments({ commit }) {
            try {
                let res = (await axios.get("/public/departments")).data;

                if (res.success)
                    commit("UPDATE_DEPARTMENTS", res.data);
                else commit("UPDATE_DEPARTMENTS", []);
            } catch (e) {
                commit("UPDATE_DEPARTMENTS", []);
            }
        },
        async getWorkshops({ commit }) {
            try {
                let res = (await axios.get("/public/workshops")).data;
                if (res.success)
                    commit("UPDATE_WORKSHOPS", res.data);
            } catch (e) {
                return e

            }
        },
        async getBlogPostsWorkshop({ commit }) {
            try {
                let res = (await axios.get("/public/workshops/blogPosts")).data;
                if (res.success)
                    commit("UPDATE_WORKSHOPS_BLOGPOSTS", res.data);
            } catch (e) {
                return e

            }
        },
        async getCourses({ commit }) {
            try {
                let res = (await axios.get("/public/courses")).data;
                if (res.success)
                    commit("UPDATE_COURSES", res.data);
            } catch (e) {
                return e

            }
        },
        async getBlogPostById({ commit }, payload) {
            try {
                let res = (await axios.get(`/public/blogPostsId/${payload.id}`)).data

                if (res.success) commit('SET_POST', res.data)
            } catch (e) {

                return e
            }
        },
        async getBlogPosts({ commit }, payload) {
            try {
                let res = (await axios.get(`/public/blogPosts/${payload}`)).data
                if (res.success) commit('SET_POSTS', res.data)
            } catch (e) {
                return e

            }
        },

        async getBlogPostCount({ commit }) {
            try {
                let res = (await axios.get(`/public/blogPostsAmount`)).data
                if (res.success) commit('SET_POSTS_AMOUNT', parseInt(res.data.count));

            } catch (error) {
                return error;
            }
        },

        async sendEmail(_context, payload) {
            try {
                let res = (await axios.post('/public/emailRequest', payload)).data;
                window.flash({ type: res.success ? "success" : "warning", msg: res.message })
                if (res.success) return true;
                else return false;
            } catch (error) {
                return error;
            }
        },

        async getBlogPostsforDepartment({ state }, payload) {
            try {
                let res = (await axios.get(`/public/blogPosts/department/${payload.name}`)).data
                if (res.success) state.departments = state.departments.map(dep => dep._id === payload.id)
            } catch (e) {
                return e

            }
        },
        async likePost({ state }, payload) {
            try {
                if (state.postsLiked.filter(post => post._id === payload)) {
                    let res = (await axios.get(`public/like/${payload}`)).data
                    state.postsLiked.push({ _id: payload })
                    window.flash({ type: res.success ? "success" : "warning", msg: res.message })

                }
            } catch (error) {
                return error;
            }
        },
        increaseViews(_context, payload) {
            axios.get(`/public/blogPost/increment/${payload}`);
        },
    }
}